module.exports = __webpack_public_path__ + "img/bx-grade-choosing-report-active.49a7348f.svg";